<template>
  <downloads-skeleton v-if="loading"></downloads-skeleton>
  <v-content id="downloadsContent" v-else>
    <v-container class="color1 pageHeader">
      <v-row>
        <v-col cols="12">
          <div class="text-center align-end justify-end">
            <h1 class="display-1">{{ $t("downloadsTitle") }}</h1>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" class="headings">
          <div class="text-left">
            <h3>{{ $t("selectTopic") }}</h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="topic in getFolderStructure" :key="topic.id" cols="12" sm="6" lg="4">
          <v-hover v-slot:default="{hover}" open-delay="100">
            <v-card
              color="color1"
              class="d-flex align-start"
              tile
              height="230"
              @click="topicClicked(topic)"
              :elevation="hover?16:2"
            >
              <v-container pt-0 pb-0>
                <v-row>
                  <v-img :src="topic.image" height="170" transition="scale-transition"></v-img>
                </v-row>
                <v-row>
                  <v-card-title>{{ topic.name }}</v-card-title>
                </v-row>
              </v-container>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import DownloadsSkeleton from "@/components/downloads/DownloadsSkeleton";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Download",
  components: {
    downloadsSkeleton: DownloadsSkeleton
  },
  data() {
    return {
      selectedFolder: null
    };
  },
  computed: {
    ...mapGetters(["loading", "getFolderStructure"])
  },
  methods: {
    ...mapActions(["fetchFileContainerFromDatabase"]),
    topicClicked (topic) {
      this.$router.push({
        name: "download",
        params: {
          topic: topic.id
        }
      });
      this.logEvent("button_click", {
        name: "downloadTopicCard",
        topic: topic.id
      })
    }
  },
  beforeMount() {
    this.fetchFileContainerFromDatabase();
  },
  mounted() {
    this.logEvent("page_load", { 
      pageName: "downloads",
      lang: this.$i18n.locale
     });
  },
  metaInfo() {
    return {
      title: "Dr. Rashmee Rajkarnikar - Materials Download",
      meta: [
        {
          name: "description",
          content: "This page contains possibility to download page of desired Study Topic. Topics include Buddhist Studies, Faculty of Management, Humanities & Social Sciences and Student Folder"
        },
        {
          property: "og:title",
          content: "Download Study Materials"
        },
        {
          property: "og:site_name",
          content: "Dr. Rashmee Rajkarnikar - Download Study Materials"
        },
        {
          property: "og:description",
          content: "Select a topic among Buddhist Studies, Faculty of Management, Humanities & Social Sciences and Student Folder to download study materials."
        },
        {
          property: "og:type",
          content: "website"
        },
        {
          property: "og:url",
          content: "https://dr-rashmee.com/en/downloads"
        },
        {
          property: "og:image",
          content: "https://firebasestorage.googleapis.com/v0/b/newecohelp.appspot.com/o/download%2FbuddhistStudies.jpg?alt=media&token=cfcdf1a6-46f8-4904-806c-f2a1f02b34b2"
        }
      ]
    }
  }
};
</script>

<style scoped>
#downloadsContent {
  padding: 0 !important;
}
.headings {
  padding-top: 0;
}
.rootFolderTitle {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>